import { render, staticRenderFns } from "./DetailedPage.vue?vue&type=template&id=05d3af3e&"
import script from "./DetailedPage.vue?vue&type=script&lang=js&"
export * from "./DetailedPage.vue?vue&type=script&lang=js&"
import style0 from "./DetailedPage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports